export default function Logo({ className = '' }: { className?: string }) {
  return (
    <svg 
      viewBox="0 0 115 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <text 
        y="18" 
        fontFamily="inherit" 
        fontSize="20" 
        fontWeight="500" 
        letterSpacing="-0.02em" 
        fill="currentColor"
      >
        revantage<tspan fill="#e07a5f">.</tspan>
      </text>
    </svg>
  )
}
